import React from 'react';
import PropTypes from 'prop-types';
import { FDNumberInput, FDStack } from '@facet-wealth/design';
import { useYearPicker } from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/useYearPicker';
import { DateInputLarge } from 'Packages/FacetDesign/Components';

export default function DateOrYearPickerFacetDesign({
  value, onChange, label, disabled, startDateField, yearLabel, helperTextValue, inputFormat, isAge,
}) {
  const yearPicker = useYearPicker({
    startDateField,
    yearLabel,
    isAge,
    dateLabel: label,
    dateValue: value,
    dateOnChange: onChange,
  });
  return (
    <FDStack spacing={1} direction="row">
      <DateInputLarge
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={label}
        helperTextValue={helperTextValue}
        inputFormat={inputFormat}
        flex={1}
      />
      {
        yearPicker ? (
          <FDNumberInput
            flex={1}
            disabled={disabled}
            {...yearPicker}
          />
        ) : null
      }
    </FDStack>
  );
}

DateOrYearPickerFacetDesign.defaultProps = {
  value: undefined,
  label: undefined,
  disabled: false,
  isAge: false,
  yearLabel: undefined,
  helperTextValue: undefined,
  inputFormat: undefined,
};

DateOrYearPickerFacetDesign.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  startDateField: PropTypes.string.isRequired,
  isAge: PropTypes.bool,
  yearLabel: PropTypes.string,
  helperTextValue: PropTypes.string,
  inputFormat: PropTypes.string,
};
